import { Stack, Typography } from '@mui/material';

import { HURDLR_SERIF } from './fields';
import { currencyExact } from './format';

interface InvoiceTotalsProps {
    subtotal: number;
    /** As entered: "10.00%" for a percentage discount, a dollar amount otherwise. */
    discountLabel: string;
    total: number;
}

export default function InvoiceTotals({ subtotal, discountLabel, total }: Readonly<InvoiceTotalsProps>) {
    return (
        <div>
            <Stack direction="row" justifyContent="space-between" sx={{ mb: 1 }}>
                <Typography variant="body2">Subtotal</Typography>
                <Typography variant="body2">{currencyExact(subtotal)}</Typography>
            </Stack>
            <Stack direction="row" justifyContent="space-between">
                <Typography variant="body2">Discount</Typography>
                <Typography variant="body2">{discountLabel}</Typography>
            </Stack>
            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="baseline"
                sx={{ borderTop: 1, borderColor: 'cement.300', mt: 3, pt: 3 }}>
                <Typography variant="h5" sx={{ fontFamily: HURDLR_SERIF, fontWeight: 400 }}>
                    Total
                </Typography>
                <Typography variant="subtitle1">{currencyExact(total)}</Typography>
            </Stack>
        </div>
    );
}
